// config for tabs
export default [
  {
    // title as shown in URL # and on the sidemenu
    componentName: 'title',
    title: 'Home',
    // we define colors here because we want to transition between these colors.
    // Therefore we need to know these colors outside of our individual section components.
    color: 'white',
    'background-color': '#087F8C',
  },

  {
    componentName: 'leistungen',
    title: 'Leistungen',
    color: 'white',
    'background-color': '#335C67',
  },


  {
    componentName: 'herangehensweise',
    title: 'Herangehensweise',
    color: 'white',
    'background-color': '#4C243B',
  },
  {
    componentName: 'sarah',
    title: 'Über mich',
    color: 'white',
    'background-color': '#533A71',
  },
  {
    componentName: 'contact',
    title: 'Kontakt',
    color: 'white',
    'background-color': '#087F8C',
  },
];
